import { eventEndPoints } from "./config"
import httpServices from "./httpServices"

export const getEventList = async () => {
    return await httpServices.get(eventEndPoints.listevent)
}
export const getstatus = async (statusData) => {
    return await httpServices.post(eventEndPoints.status, statusData)
}